import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import * as dat from 'dat.gui'
import * as CANNON from 'cannon-es'
// import cannonDebugger from 'cannon-es-debugger'

// Debug
const gui = new dat.GUI()
const debugObject = {}

debugObject.createBox = () => {
    createBox(
        Math.random(), // Width
        Math.random(), // Height
        Math.random(), // Depth
        {
            x: (Math.random() - 0.5) * 3,
            y: 3,
            z: (Math.random() - 0.5) * 3
        }
    )
}
gui.add(debugObject, 'createBox')
gui.close()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Textures
const textureLoader = new THREE.TextureLoader()
const cubeTextureLoader = new THREE.CubeTextureLoader()

const environmentMap = cubeTextureLoader.load([
    './textures/environmentMaps/1/px.png',
    './textures/environmentMaps/1/nx.png',
    './textures/environmentMaps/1/py.png',
    './textures/environmentMaps/1/ny.png',
    './textures/environmentMaps/1/pz.png',
    './textures/environmentMaps/1/nz.png'
])

// Scene
const scene = new THREE.Scene()
scene.background = new THREE.Color(0x5a7aa1)
scene.environment = environmentMap

// Scene helper
// const axesHelper = new THREE.AxesHelper(5)
// scene.add(axesHelper)

// Models
const loader = new GLTFLoader()
let chassisMesh = null
let wheelRightMesh = null
let wheelLeftMesh = null
let wheelRightFrontMesh = null
let wheelRightBackMesh = null
let wheelLeftFrontMesh = null
let wheelLeftBackMesh = null

// Vehicle chassis
loader.load('./models/muscle-car-chassis.glb', (gltf) => {
    chassisMesh = gltf.scene
    chassisMesh.traverse((node) => {
        if (node.isMesh) {
            node.castShadow = true
        }
    })
},
    (xhr) => {
        console.log('Loading: ' + (xhr.loaded / xhr.total * 100) + '% loaded')
    },
    (error) => {
        console.log('An error occurred')
    })

// Vehicle left wheel
loader.load('./models/muscle-car-wheel-right.glb', (gltf) => {
    wheelRightMesh = gltf.scene
    wheelRightMesh.traverse((node) => {
        if (node.isMesh) {
            node.castShadow = true
        }
    })
},
    (xhr) => {
        console.log('Loading: ' + (xhr.loaded / xhr.total * 100) + '% loaded')
    },
    (error) => {
        console.log('An error occurred')
    })

// Vehicle left wheel
loader.load('./models/muscle-car-wheel-left.glb', (gltf) => {
    wheelLeftMesh = gltf.scene
    wheelLeftMesh.traverse((node) => {
        if (node.isMesh) {
            node.castShadow = true
        }
    })
},
    (xhr) => {
        console.log('Loading: ' + (xhr.loaded / xhr.total * 100) + '% loaded')
    },
    (error) => {
        console.log('An error occurred')
    })

// ********** Physics **********

const objectsToUpdate = []

// World
const world = new CANNON.World()
world.broadphase = new CANNON.SAPBroadphase(world) // Improved collision detection technique (for better performance)
world.allowSleep = true
world.gravity.set(0, -9.81, 0) // Gravity constant
world.defaultContactMaterial.friction = 0

// Build the vehicle chassis
const chassisShape = new CANNON.Box(new CANNON.Vec3(2, 0.4, 1))
const chassisBody = new CANNON.Body({ mass: 150 })
chassisBody.addShape(chassisShape)
chassisBody.position.set(0, 5, 0)
chassisBody.angularVelocity.set(0, 0, 0)

// Create the vehicle
const vehicle = new CANNON.RaycastVehicle({
    chassisBody
})

const wheelOptions = {
    radius: 0.35,
    directionLocal: new CANNON.Vec3(0, -1, 0),
    suspensionStiffness: 30,
    suspensionRestLength: 0.3,
    frictionSlip: 1.4,
    dampingRelaxation: 2.3,
    dampingCompression: 4.4,
    maxSuspensionForce: 100000,
    rollInfluence: 0.01,
    axleLocal: new CANNON.Vec3(0, 0, 1),
    chassisConnectionPointLocal: new CANNON.Vec3(1, 0, -1),
    maxSuspensionTravel: 0.3,
    customSlidingRotationalSpeed: -30,
    useCustomSlidingRotationalSpeed: true,
}

wheelOptions.chassisConnectionPointLocal.set(-1, 0, 0.75) // Front-left wheel
vehicle.addWheel(wheelOptions)

wheelOptions.chassisConnectionPointLocal.set(-1, 0, -0.75) // Front-right wheel
vehicle.addWheel(wheelOptions)

wheelOptions.chassisConnectionPointLocal.set(1, 0, 0.75) // Back-left wheel
vehicle.addWheel(wheelOptions)

wheelOptions.chassisConnectionPointLocal.set(1, 0, -0.75) // Back-right wheel
vehicle.addWheel(wheelOptions)

vehicle.addToWorld(world)

// Add the wheel bodies
const wheelBodies = []
const wheelMaterial = new CANNON.Material('wheel')
vehicle.wheelInfos.forEach((wheel) => {
    const cylinderShape = new CANNON.Cylinder(wheel.radius, wheel.radius, 0.3, 20)
    const wheelBody = new CANNON.Body({
        mass: 0,
        material: wheelMaterial,
    })
    wheelBody.type = CANNON.Body.KINEMATIC
    wheelBody.collisionFilterGroup = 0 // Turn off collisions
    const quaternion = new CANNON.Quaternion().setFromEuler(-Math.PI / 2, 0, 0)
    wheelBody.addShape(cylinderShape, new CANNON.Vec3(), quaternion)
    wheelBodies.push(wheelBody)
    world.addBody(wheelBody)
})

// Update the wheel bodies
world.addEventListener('postStep', () => {
    for (let i = 0; i < vehicle.wheelInfos.length; i++) {
        vehicle.updateWheelTransform(i)
        const transform = vehicle.wheelInfos[i].worldTransform
        const wheelBody = wheelBodies[i]
        wheelBody.position.copy(transform.position)
        wheelBody.quaternion.copy(transform.quaternion)
    }
})

// Ground
const groundMaterial = new CANNON.Material('ground')
const groundShape = new CANNON.Plane()
const groundBody = new CANNON.Body({ mass: 0, material: groundMaterial }) // Mass of 0 means 'static' body
groundBody.addShape(groundShape)

// Quarter rotation on the x-axis
groundBody.quaternion.setFromAxisAngle(new CANNON.Vec3(-1, 0, 0), Math.PI * 0.5)
world.addBody(groundBody)

// Define interactions between the wheels and ground
const wheelGroundContactMaterial = new CANNON.ContactMaterial(wheelMaterial, groundMaterial, {
    friction: 0.3,
    restitution: 0,
    contactEquationStiffness: 1000,
})
world.addContactMaterial(wheelGroundContactMaterial)

// Keybindings

// Add force on keydown
document.addEventListener('keydown', (event) => {
    const maxSteerVal = 0.5
    const maxForce = 500
    const brakeForce = 15

    switch (event.key) {
        case 'w':
        case 'ArrowUp':
            vehicle.applyEngineForce(-maxForce, 2)
            vehicle.applyEngineForce(-maxForce, 3)
            break
        case 's':
        case 'ArrowDown':
            vehicle.applyEngineForce(maxForce, 2)
            vehicle.applyEngineForce(maxForce, 3)
            break
        case 'a':
        case 'ArrowLeft':
            vehicle.setSteeringValue(maxSteerVal, 0)
            vehicle.setSteeringValue(maxSteerVal, 1)
            break
        case 'd':
        case 'ArrowRight':
            vehicle.setSteeringValue(-maxSteerVal, 0)
            vehicle.setSteeringValue(-maxSteerVal, 1)
            break
        case 'b':
            vehicle.setBrake(brakeForce, 0)
            vehicle.setBrake(brakeForce, 1)
            vehicle.setBrake(brakeForce, 2)
            vehicle.setBrake(brakeForce, 3)
            break
    }
})

// Reset force on keyup
document.addEventListener('keyup', (event) => {
    switch (event.key) {
        case 'w':
        case 'ArrowUp':
            vehicle.applyEngineForce(0, 2)
            vehicle.applyEngineForce(0, 3)
            break
        case 's':
        case 'ArrowDown':
            vehicle.applyEngineForce(0, 2)
            vehicle.applyEngineForce(0, 3)
            break
        case 'a':
        case 'ArrowLeft':
            vehicle.setSteeringValue(0, 0)
            vehicle.setSteeringValue(0, 1)
            break
        case 'd':
        case 'ArrowRight':
            vehicle.setSteeringValue(0, 0)
            vehicle.setSteeringValue(0, 1)
            break
        case 'b':
            vehicle.setBrake(0, 0)
            vehicle.setBrake(0, 1)
            vehicle.setBrake(0, 2)
            vehicle.setBrake(0, 3)
            break
    }
})

// ********** Visible world **********

// Ground
const groundMesh = new THREE.Mesh(
    new THREE.PlaneGeometry(40, 40),
    new THREE.MeshStandardMaterial({
        color: '#777777',
        metalness: 0.3,
        roughness: 0.7,
        envMap: environmentMap
    })
)
groundMesh.receiveShadow = true
groundMesh.rotation.x = - Math.PI * 0.5
scene.add(groundMesh)

// Lights
const ambientLight = new THREE.AmbientLight(0xffffff, 1)
scene.add(ambientLight)

const directionalLight = new THREE.DirectionalLight(0xffffff, 5)
directionalLight.castShadow = true
directionalLight.shadow.mapSize.set(2048, 2048)
directionalLight.shadow.camera.far = 40
directionalLight.shadow.camera.left = -20
directionalLight.shadow.camera.top = 20
directionalLight.shadow.camera.right = 20
directionalLight.shadow.camera.bottom = -20
directionalLight.position.set(0, 15, 15)
scene.add(directionalLight)

// Shadow camera helper
// const shadowCameraHelper = new THREE.CameraHelper(directionalLight.shadow.camera)
// scene.add(shadowCameraHelper)

// Viewport dimensions
const dimensions = {
    width: window.innerWidth,
    height: window.innerHeight
}

// Events
window.addEventListener('resize', () => {
    // Update sizes
    dimensions.width = window.innerWidth
    dimensions.height = window.innerHeight

    // Update camera
    camera.aspect = dimensions.width / dimensions.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(dimensions.width, dimensions.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

// https://supernapie.com/blog/keyboard-focus-in-an-iframe/
window.addEventListener('load', function () {
    window.focus();
    document.body.addEventListener('click', function (e) {
        window.focus();
    }, false);
});

window.addEventListener('dblclick', () => {
    const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement

    if (!fullscreenElement) {
        if (canvas.requestFullscreen) {
            canvas.requestFullscreen()
        }
        else if (canvas.webkitRequestFullscreen) {
            canvas.webkitRequestFullscreen()
        }
    }
    else {
        if (document.exitFullscreen) {
            document.exitFullscreen()
        }
        else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen()
        }
    }
})

// Camera
const camera = new THREE.PerspectiveCamera(45, dimensions.width / dimensions.height, 0.1, 100)
camera.position.set(-3, 6, -4)
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

// Renderer
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.physicallyCorrectLights = true
renderer.outputEncoding = THREE.sRGBEncoding
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setSize(dimensions.width, dimensions.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.setClearColor(0x000000, 1)

// Box
const boxGeometry = new THREE.BoxBufferGeometry(1, 1, 1)
const boxMaterial = new THREE.MeshStandardMaterial({
    metalness: 0.3,
    roughness: 0.4,
    envMap: environmentMap
})

const createBox = (width, height, depth, position) => {
    // Create mesh
    const mesh = new THREE.Mesh(
        boxGeometry,
        boxMaterial
    )
    mesh.scale.set(width, height, depth)
    mesh.castShadow = true
    mesh.position.copy(position)
    scene.add(mesh)

    // Create physics body
    const shape = new CANNON.Box(new CANNON.Vec3(width * 0.5, height * 0.5, depth * 0.5))
    const body = new CANNON.Body({
        mass: 1,
        position: new CANNON.Vec3(0, 0, 0),
        shape: shape,
        material: wheelMaterial
    })
    body.position.copy(position)
    world.addBody(body)

    // Save in objects to update
    objectsToUpdate.push({
        mesh: mesh,
        body: body
    })
}

// Animation
const clock = new THREE.Clock()
let previousElapsedTime = 0

let executed = false

// Cannon debugger
// cannonDebugger(scene, world.bodies)

const tick = () => {
    // Initialisation
    if (!executed) {
        if (chassisMesh && wheelRightMesh && wheelLeftMesh) {
            scene.add(chassisMesh)
            objectsToUpdate.push({
                mesh: chassisMesh,
                body: chassisBody
            })

            wheelRightFrontMesh = wheelRightMesh.clone()
            wheelRightBackMesh = wheelRightMesh.clone()
            wheelLeftFrontMesh = wheelLeftMesh.clone()
            wheelLeftBackMesh = wheelLeftMesh.clone()

            scene.add(wheelRightFrontMesh)
            scene.add(wheelRightBackMesh)
            scene.add(wheelLeftFrontMesh)
            scene.add(wheelLeftBackMesh)

            objectsToUpdate.push({
                mesh: wheelRightBackMesh,
                body: wheelBodies[0]
            })
            objectsToUpdate.push({
                mesh: wheelLeftBackMesh,
                body: wheelBodies[1]
            })
            objectsToUpdate.push({
                mesh: wheelRightFrontMesh,
                body: wheelBodies[2]
            })

            objectsToUpdate.push({
                mesh: wheelLeftFrontMesh,
                body: wheelBodies[3]
            })

            executed = true
        }
    }

    // Time
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousElapsedTime
    previousElapsedTime = elapsedTime

    // Update physics world
    world.step(1 / 60, deltaTime, 3) // Steps the physics world forward in time

    for (const object of objectsToUpdate) {
        object.mesh.position.copy(object.body.position)
        object.mesh.quaternion.copy(object.body.quaternion)
    }

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick (function) again on the next frame
    window.requestAnimationFrame(tick)
}

tick()